module.exports = __webpack_public_path__ + "img/pic_russia_05.a82dfe2e.jpg";